module.exports = __webpack_public_path__ + "img/tab3.4cb8bbd0.png";